import React, { useState, useRef } from "react";
import { Button, Upload, Modal } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import UploadIcon from "../../image/uploadadd.svg";
import Trash from "../../image/trash.svg";
import PreView from "../../image/big.svg";
import { uploadSoftInfo } from "../../service/register";
import { message } from "../../components/Message";

import styles from "./index.modules.less";

const CustomUpload = ({
  maxCount,
  tips,
  value,
  onChange,
  fileList,
  name,
  form,
  accept,
  width,
  height,
  size
}) => {
  function customRequest(option) {
    const reader = new FileReader();
    reader.readAsDataURL(option.file);
    reader.onloadend = function(e) {
      console.log(e.target.result); // 打印图片的base64
      if (e && e.target && e.target.result) {
        let base64Header = "data:image/png;base64,";
        // 删除头部以获取实际编码数据
        // console.log("atob() is", atob(e.target.result))
        let base64Data = e.target.result.replace(
          /^data:image\/(jpeg|png|gif);base64,/,
          ""
        );

        uploadSoftInfo({
          pic_base64: base64Data,
        })
          .then((res) => {
            option.onSuccess(res);
          })
          .catch((e) => {
            option.onError(e);
            message.show({
              type: "error",
              content: "上传错误",
            });
            // option.actions.remove(option.fileList)
          });
      }
    };
  }

  async function handleBeforeUpload(file, fileList)  {
    console.log("file is", file);
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.show({
        type: "error",
        content: "上传类型为 JPG/PNG",
      });
      return Upload.LIST_IGNORE;
    }
    const isGt30M = (file.size / 1024 / 1024) > size;
    if (isGt30M) {
      message.show({
        type: "error",
        content: `图片不能大于${size}M!`,
      });
      return Upload.LIST_IGNORE;
    }

     function  isValidSize (){
      return new Promise((resolve, reject) => {
        if (width && height) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = function(e) {
            console.log(e.target.result); // 打印图片的base64
            const data = e.target.result;
            var image = new Image();
            image.onload = function() {
              var imgWidth = image.width;
              var imgHeight = image.height;
              if (imgWidth != width || imgHeight != height) {
                message.show({
                  type: "error",
                  content: "图片宽高设置不正确!",
                });
                resolve(false)
              }
              resolve(true)
            };
            image.src = data;
          };
        } else {
          resolve(true)
        }

      }) 

    };


    const vaildSize =  await isValidSize()
    
    // console.log("vaildSize is", vaildSize)
    return (isJpgOrPng && !isGt30M &&  vaildSize) || Upload.LIST_IGNORE;
  };

  const [preview, setPreview] = useState({
    isOpen: false,
    seeImage: "",
    setTitle: "",
  });

  const [upFileList, setUpFilelist] = useState([]);

  const CustomItemRender = (originNode, file, fileList, actions) => {
    if (file?.status != "done") {
      return originNode;
    }
    return (
      <div className="custom-item-renderer">
        <img src={file?.response?.pic_url} alt={file.name} />
        <div className="buttons flex mt-1 ">
          {/* <Button size="small" onClick={() => handlePreview(fileList)}>
            View
          </Button>
          <Button size="small" onClick={() => onRemove(fileList)}>
            Delete
          </Button> */}
          <div className="mask-r">
            <div
              onClick={() =>
                actions.preview(
                  setPreview({
                    isOpen: true,
                    seeImage: file?.response?.pic_url,
                    setTitle: file.name,
                  })
                )
              }
            >
              <PreView
                className="mask-icon preview"
                width="15"
                height="15"
              ></PreView>
            </div>
            <div onClick={() => actions.remove(fileList)}>
              <Trash className="mask-icon" width="15" height="15"></Trash>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleOnChange = (info) => {
    let newFileList = [...info.fileList];

    newFileList = newFileList.map((file) => {
      if (file.response) {
        // Component will show file.url as link
        file.url = file.response.pic_url;
      }
      return file;
    });

    form.setFieldsValue({
      [name]: newFileList,
    });
  };
  console.log("value is", value);
  return (
    <>
      <Upload
        className="custom_upload"
        onChange={handleOnChange}
        itemRender={CustomItemRender}
        listType="picture-card"
        customRequest={customRequest}
        beforeUpload={handleBeforeUpload}
        action="/main/plat/v1/softmgr/uploadpic"
        fileList={fileList}
        accept={accept}
      >
        {fileList?.length >= maxCount ? null : (
          <div className={styles.uploadCt}>
            <div className={styles.UploadIcon}>
              <UploadIcon></UploadIcon>
            </div>
            <div className={styles.uploadText}>点击添加图片</div>
          </div>
        )}
      </Upload>
      <div className={styles.uploadTips}>{tips}</div>
      <Modal
        open={preview.isOpen}
        title={preview.setTitle}
        footer={null}
        onCancel={() =>
          setPreview({ isOpen: false, seeImage: "", setTitle: "" })
        }
      >
        <img style={{ width: "100%" }} src={preview.seeImage} alt="example" />
      </Modal>
    </>
  );
};

export default CustomUpload;
